/// <amd-module name="Feed/Legacy/Dialogs/PromoteDialog" />
import * as React from "react";

import { Dropdown, IDropdownOption } from "OfficeFabric/Dropdown";
import { IIconProps } from "OfficeFabric/Icon";

import { Dialog } from "VSSUI/Dialog";
import { css } from "VSSUI/Util";

import { FeedView, FeedViewType, Package, PackageVersion } from "Feed/Common/Contracts/Feed";
import * as PackageResources from "Feed/Common/Resources";
import { PackageVersionPromoted, TogglePromoteDialog } from "Feed/Legacy/Actions/Actions";
import { IMultiCommandPackageDetails, IPackagePromotedPayload } from "Feed/Legacy/Common/ActionPayloads";
import { Feed } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";

export interface IPromoteDialogProps {
    feed: Feed;
    selectedPackage: Package;
    selectedVersion: PackageVersion;
    views: FeedView[];
    isLoading?: boolean;
}

export interface IPromoteDialogState {
    selectedViewOption?: IDropdownOption;
}

export class PromoteDialog extends React.Component<IPromoteDialogProps, IPromoteDialogState> {
    constructor(props: IPromoteDialogProps) {
        super(props);

        const alreadyPromotedViewIds = props.selectedVersion.views.map(v => v.id);
        this._viewOptions = props.views
            .filter(view => view.type != FeedViewType.Implicit)
            .filter(view => alreadyPromotedViewIds.indexOf(view.id) < 0)
            .map(view => {
                return {
                    key: view.id,
                    text: `${props.feed.name}@${view.name}`,
                    data: view
                } as IDropdownOption;
            });

        this.state = {
            selectedViewOption: this._viewOptions.length > 0 ? this._viewOptions[0] : null
        };
    }

    public render(): JSX.Element {
        return (
            <Dialog
                lightDismiss={false}
                onDismiss={this._closeDialog}
                titleProps={{ text: PackageResources.PackageOperationsMenu_ReleasePackageDialogTitle }}
                footerButtonProps={[
                    {
                        primary: true,
                        onClick: this._save,
                        disabled: this.state.selectedViewOption == null || this.props.isLoading === true,
                        text: PackageResources.PromotePackage_PromoteButton,
                        iconProps: this._getPrimaryButtonIconProps()
                    },
                    {
                        className: "promote-dialog-cancel-button",
                        onClick: this._closeDialog,
                        text: PackageResources.Dialog_CancelButtonText
                    }
                ]}
            >
                {
                    <div className="promote-dialog-content">
                        {this._viewOptions.length < 1 ? (
                            <span>{PackageResources.ReleaseDialogContent_NoMoreViews}</span>
                        ) : (
                            <Dropdown
                                options={this._viewOptions}
                                selectedKey={this.state.selectedViewOption && this.state.selectedViewOption.key}
                                label={PackageResources.FeedViewDropdown_Title}
                                onChanged={viewOption => this._onChanged(viewOption)}
                            />
                        )}
                    </div>
                }
            </Dialog>
        );
    }

    private _getPrimaryButtonIconProps(): IIconProps {
        if (this.props.isLoading === true) {
            return {
                className: css("bowtie-icon bowtie-spinner save-progress")
            } as IIconProps;
        }

        return null;
    }

    private _closeDialog = (): void => {
        TogglePromoteDialog.invoke(false);
    };

    private _save = (): void => {
        const packagePromotedDetails: IPackagePromotedPayload = {
            minimalPackageDetails: [
                {
                    id: this.props.selectedPackage.name,
                    version: this.props.selectedVersion.version,
                    protocolType: this.props.selectedPackage.protocolType
                }
            ] as IMultiCommandPackageDetails[],
            promotedView: this.state.selectedViewOption.data
        };
        PackageVersionPromoted.invoke(packagePromotedDetails);
    };

    private _onChanged = (viewOption: IDropdownOption): void => {
        this.setState({ selectedViewOption: viewOption });
    };

    private _viewOptions: IDropdownOption[];
}
